import DOMPurify from 'dompurify';

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'div', 'span', 'table', 'tr', 'td', 'th',
      'thead', 'tbody', 'img', 'blockquote', 'hr',
    ],
    ALLOWED_ATTR: [
      'href', 'src', 'alt', 'style', 'class', 'target', 'width', 'height',
    ],
  });
}
